import common from './common'
import { DOMAIN_RELATED, SDK_PRODUCT } from '@/config/dataMap'
const deviceAdminOperateKfmt = 'duba_newvip_loginlimit_page_box:6255 click:byte box_type:byte ver:byte product_id:int'

const deviceAdminShowKfmt = 'duba_newvip_loginlimit_page:6254 source:byte ver:byte product_id:int'

export default {
  API: {
    openDeviceAdmin ({ token, open_id, sfrom }) {
      const params = {
        url: `${DOMAIN_RELATED.domain}${DOMAIN_RELATED.channel}/device/admin?token=${token}&openid=${open_id}&sfrom=${sfrom}`,
        open_web: 'dev_mgr',
        width: 600,
        height: 420
      }
      common.API.client_openOptionWindow(params)
    }
  },
  REPORT: {
    reportDeviceAdminOperate (params) {
      const info = {
        click: 0,
        box_type: 0,
        ver: 1,
        product_id: SDK_PRODUCT.id
      }
      return common.REPORT.client_report_by_kfmt(deviceAdminOperateKfmt, common.API.replaceObj(info, params))
    },
    reportDeviceAdminShow (params) {
      const info = {
        source: 0,
        ver: 1,
        product_id: SDK_PRODUCT.id
      }
      return common.REPORT.client_report_by_kfmt(deviceAdminShowKfmt, common.API.replaceObj(info, params))
    }
  }
}
